import { parse, stringify } from '@/helpers/qs'
import { decode, encode } from '@/helpers/param-encoder'
import type {
    GemsApi_GemstoneTypeFilter,
    GemsApi_GemstoneTypeFilterInput,
    GemsApi_StoneFilters,
    GemsApi_StoneSorting,
} from '@/graphql/api'

export const decodeSkuGemstoneFiltersAndSort = (
    fragment: string | undefined
): DecodedGemstoneFiltersAndIdentifier | undefined => {
    if (!fragment) {
        return undefined
    }

    const parsed = parse(fragment)

    return {
        filters:
            typeof parsed['filters'] === 'string'
                ? decode(parsed['filters'])
                : undefined,
        sort:
            typeof parsed['sort'] === 'string'
                ? decode(parsed['sort'])
                : undefined,
        stoneId:
            typeof parsed['stoneId'] === 'string'
                ? parsed['stoneId']
                : undefined,
    }
}

export const encodeSkuGemstoneParams = (
    filters: GemsApi_StoneFilters | undefined,
    sort: GemsApi_StoneSorting | undefined,
    stoneId: string | undefined = undefined
): string | undefined => {
    const fragment = {
        filters: encode(filters),
        sort: encode(sort),
        stoneId: stoneId,
    }

    return Object.values(fragment).filter((v) => !!v).length
        ? `#${stringify(fragment)}`
        : undefined
}

export function getGemstoneTypeNameNew(
    type: GemsApi_GemstoneTypeFilter
): string {
    return `${type.colorWithInfo.info?.translation.name} ${type.crystalWithInfo.info?.translation.name}`
}

export function isSameGemstoneType(
    a: GemsApi_GemstoneTypeFilter,
    b: GemsApi_GemstoneTypeFilter
): boolean {
    return a.colour === b.colour && a.crystal === b.crystal
}

export function isGemstoneTypeFilterInputSameAsFilter(
    a: GemsApi_GemstoneTypeFilterInput,
    b: GemsApi_GemstoneTypeFilter
): boolean {
    return a.colour === b.colour && a.crystal === b.crystal
}

export type DecodedGemstoneFiltersAndIdentifier = {
    filters: GemsApi_StoneFilters | undefined
    sort: GemsApi_StoneSorting | undefined
    stoneId: string | undefined
}
